import {
  computed,
  Directive,
  InjectionToken,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
export const SUFFIX_DIRECTIVE: InjectionToken<SuffixDirective> =
  new InjectionToken<SuffixDirective>('SuffixDirective');

@Directive({
  selector: '[lyceoIconSuffix], [lyceoTextSuffix]',
  providers: [{ provide: SUFFIX_DIRECTIVE, useExisting: SuffixDirective }],
})
export class SuffixDirective {
  public readonly lyceoTextSuffix: InputSignal<'' | undefined> = input<''>();

  public readonly isText: Signal<boolean> = computed<boolean>(
    () => this.lyceoTextSuffix() !== undefined,
  );
}
